$(function (){
    /* carousel */
    $('#carouselExampleIndicators').carousel({
        interval: false,
    }).carousel(0);

    /* carousel pause */
    $('.carousel-indicators li, .carousel-control-next, .carousel-control-prev').click(function(){
        $('#carouselExampleIndicators').carousel('pause');
    });

    /* carousel play */
    $('.button-play').click(function(){
        //set options carousel
        $('#carouselExampleIndicators').carousel('dispose');
        $('#carouselExampleIndicators').carousel({
            interval: 1200,
            pause: false,
            wrap: false
        }).carousel(0);
    });
});